export type FileType = 'docx' | 'excel' | 'pdf' | 'ppt' | 'markdown' | 'txt' | 'unknown';

const MARKDOWN_SUFFIXES = ['.md', '.markdown', '.mdown', '.mdx'];
const EXCEL_SUFFIXES = ['.xlsx'];
const WORD_SUFFIXES = ['.docx'];
const PPT_SUFFIXES = ['.pptx'];
const TXT_SUFFIXES = ['.txt', '.log', '.text', '.conf', '.ini'];

export function getSuffix(filename: string): string {
  if (!filename || typeof filename !== 'string') {
    return '';
  }
  const clean = filename.split(/[?#]/, 1)[0];
  const lastDot = clean.lastIndexOf('.');
  if (lastDot === -1) {
    return '';
  }
  return clean.substring(lastDot).toLowerCase();
}

export function getFileType(filename: string): FileType {
  const suffix = getSuffix(filename);
  if (!suffix) {
    return 'unknown';
  }
  if (suffix === '.docx') {
    return 'docx';
  }
  if (EXCEL_SUFFIXES.includes(suffix)) {
    return 'excel';
  }
  if (suffix === '.pdf') {
    return 'pdf';
  }
  if (PPT_SUFFIXES.includes(suffix)) {
    return 'ppt';
  }
  if (MARKDOWN_SUFFIXES.includes(suffix)) {
    return 'markdown';
  }
  if (TXT_SUFFIXES.includes(suffix)) {
    return 'txt';
  }
  return 'unknown';
}

export function isMarkdown(filename: string): boolean {
  return getFileType(filename) === 'markdown';
}
